<template>
  <div>
    <response v-if="!_.isEmpty(errors)" :items="errors"></response>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    code: null
  },
  data () {
    return {
      errors: [],
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/signUpUser'
    })
  },
  methods: {
    ...mapActions({
      getUser: 'auth/getUserByCode',
      confirmEmail: 'auth/confirmEmail'
    }),
    confirmSuccess () {
      this.$router.push({name: `SignUp.Step3.${this.$i18n.i18next.language}`})
    }
  },
  mounted () {
    const code = this.$route.params.code // http://localhost:8080/signup/4b3403665fea6
    this.confirmEmail({ code: code, context: this })
    // this.confirmEmail({ code: code, context: this }).then((response) => {
    //   this.$router.push({name: `SignUp.Step3.${this.$i18n.i18next.language}`})
    // }).catch((error) => {
    //   if (error.response.status === 404) {
    //     this.$router.push({name: `Home.${this.$i18n.i18next.language}`})
    //   }
    // })
  }
}
</script>
